export var INCREASE_BOOKMARKS_COUNT = "INCREASE_BOOKMARKS_COUNT";
export var DECREASE_BOOKMARKS_COUNT = "DECREASE_BOOKMARKS_COUNT";
export var UPDATE_BOOKMARKS_COUNT = "UPDATE_BOOKMARKS_COUNT";
export var BOOKMARKS_START_LOADER = "BOOKMARKS_START_LOADER";
export var BOOKMARKS_STOP_LOADER = "BOOKMARKS_STOP_LOADER";
export var BOOKMARKS_ERROR = "BOOKMARKS_ERROR";
export var BOOKMARKS_HIDE_ERROR = "BOOKMARKS_HIDE_ERROR";
